import { FileExcelOutlined } from '@ant-design/icons';
import {
    Button, Card, Input, Space,
} from 'antd';
import FileDownload from 'js-file-download';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useRef, useState } from 'react';
import OrdersList, { IOrdersListRef } from '../components/orders-list';
import FetchService from '../services/fetch';
import OrdersNotifyServicesButtont from '../components/orders-notify-services-buttont';
import { IOrder } from '../types/order';
import RusPostSendManifestButton from '../components/RusPost/send-manifest-button';

function OrdersPage() {
    const [params, setParams] = useSearchParams();
    const { t } = useTranslation();
    const [selectedRows, setSelectedRows] = useState<IOrder[]>([]);
    const ordersRef = useRef<IOrdersListRef>();

    const onExportClick = async () => {
        const result = await FetchService.downloadFile({
            url: '/orders?export=excel',
            method: 'POST',
        });
        if (result.success && result.data) {
            FileDownload(result.data, 'Список заявок.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        }
    };

    const onNotified = () => {
        ordersRef.current?.clearSelectedRows();
        ordersRef.current?.update();
    };

    const extra = (
        <Space>
            <RusPostSendManifestButton
                selectedRows={selectedRows}
                onHide={onNotified}
            />
            <OrdersNotifyServicesButtont
                disabled={selectedRows.filter((el) => el.paid_data_updated).length === 0}
                onNotified={onNotified}
                selectedRows={selectedRows}
            />
            <Input.Search
                allowClear
                defaultValue={params.get('search') || undefined}
                placeholder="Поиск..."
                onSearch={(val) => {
                    params.set('search', val);
                    params.set('page', '1');
                    setParams(params);
                }}
            />
            <Button
                icon={<FileExcelOutlined />}
                type="primary"
                title={t('exportToExcel') as string}
                onClick={onExportClick}
            />
        </Space>
    );

    return (
        <Card title={t('ordersInfo')} extra={extra}>
            <OrdersList
                ref={ordersRef}
                search={params.get('search') || undefined}
                rowSelection
                onSelectedRowsChange={setSelectedRows}
            />
        </Card>
    );
}

export default OrdersPage;
